module.exports = __webpack_public_path__ + "img/18-small.e9f57c68.png";